var passiveSupported = null;
export function passiveEventSupported() {
    // memoize support to avoid adding multiple test events
    if (typeof passiveSupported === "boolean")
        return passiveSupported;
    var supported = false;
    try {
        var options = {
            get passive() {
                supported = true;
                return false;
            },
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    }
    catch (err) {
        supported = false;
    }
    passiveSupported = supported;
    return passiveSupported;
}
//# sourceMappingURL=get-passive-event-support.js.map